import { Accept } from "react-dropzone";

/**
 * Validates a file based on the provided accept criteria (MIME types and extensions).
 *
 * @param file The file to validate.
 * @param accept An object defining acceptable MIME types and/or file extensions.
 *               Example: { 'image/png': ['.png'], 'image/jpeg': ['.jpg', '.jpeg'] }
 * @returns True if the file is valid according to the accept criteria, false otherwise.
 */
export const validateFile = (file: File, accept?: Accept): boolean => {
  if (!accept || Object.keys(accept).length === 0) {
    // No criteria or empty criteria means accept all
    return true;
  }

  const mimeType = file.type.toLowerCase();
  const fileName = file.name.toLowerCase();

  return Object.entries(accept).some(([mimePattern, extensions]) => {
    const lowerCaseMimePattern = mimePattern.toLowerCase();

    // Check MIME type match (exact or wildcard)
    const isMimeMatch =
      lowerCaseMimePattern === mimeType ||
      (lowerCaseMimePattern.endsWith("/*") &&
        mimeType.startsWith(lowerCaseMimePattern.replace("/*", "")));

    // Check extension match (case-insensitive)
    const isExtensionMatch = extensions.some((ext) =>
      fileName.endsWith(ext.toLowerCase()),
    );

    return isMimeMatch || isExtensionMatch;
  });
};
